import React from 'react';
import styled from 'styled-components';
import GeneralContext from '../contexts/GeneralContext';
import { MobileWidth } from '../sharedData/Constants';

const Button = (props) => {
    return (
        <GeneralContext.Consumer>
        {data => (
            <StyledButton type={"submit"} disabled={props.disabled} onClick={props.onClick} style={{width: data.buttonWidth ? data.buttonWidth : '175px', backgroundColor: data.buttonBackgroundColor, color: data.buttonTextColor}} className="button">
            	{data.buttonTitle}
           	</StyledButton>
        )}
      </GeneralContext.Consumer>
    );
}

const StyledButton = styled.button`
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    font-weight: 700;  
    height: 48px;
    border-radius: 25px;
    font-size: 16px;
    min-height: 48px;
    border: none;
    @media screen and (max-width: ${MobileWidth}){
      width: 160px;
      z-index: 9;
      pointer-events:  all;
    }
    :disabled{
      opacity: 0.5;
      cursor: auto;
    }
`;

export default Button;